import { routeManager } from '../route';
import { PermissionManager } from './permission';

export const permissionManager = new PermissionManager(routeManager);
